import getNative from './_getNative.js';
import root from './_root.js';

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

export default Promise;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_Promise.js
// module id = 646
// module chunks = 7